export default __webpack_public_path__ + "static/media/TooltTip.82c92273.svg";